import styled from 'styled-components';
import { Route } from 'react-router-dom';
import { CreatePreFillableForm } from './CreatePreFillableForm/CreatePreFillableForm';
import { PreFillableFormsTable } from './PreFillableFormsTable/PreFillableFormsTable';
import { EditPreFillableForm } from '@dealstack/frontend/admin/pages/Manage/ManagePreFillableForms/EditPreFillableForm/EditPreFillableForm.tsx';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry.ts';

interface Props {
	className?: string;
}

export enum MANAGE_PRE_FILLABLE_FORMS_ROUTES {
	CREATE = 'create',
	EDIT = 'edit/:templateId',
}

const ManagePreFillableForms = ({ className }: Props) => {
	return (
		<div className={className}>
			<SentryRoutes>
				<Route
					path={MANAGE_PRE_FILLABLE_FORMS_ROUTES.CREATE}
					element={<CreatePreFillableForm />}
				/>
				<Route
					path={MANAGE_PRE_FILLABLE_FORMS_ROUTES.EDIT}
					element={<EditPreFillableForm />}
				/>

				<Route path="*" element={<PreFillableFormsTable />} />
			</SentryRoutes>
		</div>
	);
};

const Styled = styled(ManagePreFillableForms)`
	padding: 2rem;
	color: ${(props) => props.theme.v3.colors.dark[8]};
`;

export { Styled as ManagePreFillableForms };
